export function LoadingState({ nome }: { nome: string }) {
  return (
    <div className="card flex flex-col items-center px-8 py-16 text-center">
      <div className="mb-5 h-10 w-10 animate-spin rounded-full border-2 border-line-2 border-t-transparent"
        style={{ borderTopColor: 'var(--accent-bright)' }}
      />
      <h2 className="text-lg font-semibold text-ink">Processando sua base…</h2>
      <p className="mt-2 max-w-md text-sm text-ink-3">
        O agente está lendo <span className="text-ink-2">{nome}</span> e mapeando as colunas para o
        schema. Isso pode levar alguns segundos.
      </p>
    </div>
  );
}
